import React, {Suspense} from 'react';
import {AsyncComponent} from "../../../../../core/components/router/async-component";

const SiteHeaderModuleAsyncComponent = AsyncComponent(async () => import('./site-header-module' /* webpackChunkName: "site-header-module" */ ));

export const SiteHeaderModuleAsync = (props) => {
  return <Suspense fallback={<div/>}><SiteHeaderModuleAsyncComponent {...props}/></Suspense>
}
